const productbannData ={
        id: 1,
        img: "assets/images/arrival-bg.png",
        heading: "Free shipping worldwide on all baskets over $200",
        button: "Go to shop"
    }
module.exports = productbannData;
